export const cdccNumberLengthStrategy = (value: string) => {
  return value.length === 16;
};
